module.exports = __webpack_public_path__ + "static/media/cog.c2f13f17.svg";